import { AxiosResponse } from 'axios'
import { PlusUser } from 'src/types/plusUser'

import axios from '../../axios'

export const fetchPlusUser = async (id: string): Promise<AxiosResponse> => {
  const response = await axios
    .get<{ data: PlusUser }>(`/api/plus-users/${id}`)
    .catch((error) => {
      return error.response
    })

  return response
}
